<div *ngIf="carrierInformation"
     [ngStyle]="carrierInformation?.brandColor && {'border-left': carrierInformation.brandColor+' 10px solid'}">

    <div class="branded-help">
        <img *ngIf="carrierInformation._logoFullPath" class="carrier-logo-image" [src]="carrierInformation._logoFullPath" alt="Carrier Logo">

        <h1 class="suif-h3 carrier-intro">{{carrierInformation.carrierName}} is partnering with Sircon to make selling easier</h1>

        <ng-container *ngIf="!messageOverride">
            <div *ngIf="!carrierInformation.brandLoginMessage">
            Sign in to access your Sircon account.  If you don't have an account and want to connect with {{carrierInformation.carrierName}},
            use one of the contacts below to request a connection.
            </div>
            <div *ngIf="carrierInformation.brandLoginMessage" [innerHTML]="carrierInformation.brandLoginMessage"></div>
        </ng-container>
        <div *ngIf="messageOverride">{{messageOverride}}</div>

        <div *ngIf="carrierInformation.emailAddress || carrierInformation.phoneNumber || carrierInformation.helpLink"
             class="suif-body-copy-secondary help-tagline">Need help or have questions? Contact {{carrierInformation.carrierName}} Support</div>

        <div class="help-container">
            <div *ngIf="carrierInformation.helpLink" class="help-item">
                <img src="/src/images/icon-website.svg" alt="">
                <dl class="suif-labeled-list">
                    <dt>Website</dt>
                    <dd><a target="_blank" href="{{carrierInformation.helpLink}}">{{carrierInformation.helpWebsiteName}}</a></dd>
                </dl>
            </div>

            <div *ngIf="carrierInformation.emailAddress" class="help-item">
                <img src="/src/images/icon-email.svg" alt="">
                <dl class="suif-labeled-list">
                    <dt>Email</dt>
                    <dd><a href="mailto:{{carrierInformation.emailAddress}}">{{carrierInformation.emailAddress}}</a></dd>
                </dl>
            </div>

            <div *ngIf="carrierInformation.phoneNumber" class="help-item">
                <img src="/src/images/icon-phone.svg" alt="">
                <dl class="suif-labeled-list">
                    <dt>Phone</dt>
                    <dd>{{carrierInformation.phoneNumber ? (carrierInformation.phoneNumber | mask:'(000) 000-0000') : ''}}</dd>
                </dl>
            </div>
        </div>
    </div>
</div>
